/**
 * JavaScript responsible for showing post type specific facets in faceted search when post type
 * selection is changed.
 */
(() => {
    let main = document.querySelector('.js-faceted-search-main-container');
    let radio_buttons = document.querySelectorAll(
        '.js-faceted-search-post-type-radio-button'
    );
    let headers = document.querySelectorAll(
        '.js-faceted-search-filters-header'
    );
    let facets = document.querySelectorAll(
        '.js-faceted-search-facet-container'
    );

    if (!main || !radio_buttons.length || !headers.length || !facets.length) {
        return;
    }

    function get_facet_container(post_type) {
        for (let i = 0; i < facets.length; i++) {
            const facet_post_type = facets[i].getAttribute('data-pt');
            if (facet_post_type === post_type) {
                return facets[i];
            }
        }
    }

    function has_facets(post_type) {
        // console.log('Checking if post type ' + post_type + ' has facets');

        return (
            get_facet_container(post_type).getAttribute('data-has-facets') ===
            'true'
        );
    }

    function activate(post_type) {
        // console.log('Activating post type ' + post_type);

        // Toggle a modifier class to indicate if this post type has facets
        if (has_facets(post_type)) {
            main.classList.remove('-no-facets');
        } else {
            main.classList.add('-no-facets');
        }

        // Show post type header
        headers.forEach(function (header) {
            const header_post_type = header.getAttribute('data-pt');

            if (header_post_type === post_type) {
                header.classList.add('-visible');
            } else {
                header.classList.remove('-visible');
            }
        });

        // Show post type facets
        facets.forEach(function (facet) {
            const facet_post_type = facet.getAttribute('data-pt');

            if (facet_post_type === post_type) {
                facet.classList.add('-visible');
            } else {
                facet.classList.remove('-visible');
            }
        });
    }

    function radioButtonClicked() {
        if (this.checked) {
            activate(this.getAttribute('value'));
        }
    }

    radio_buttons.forEach(function (radio_button) {
        radio_button.addEventListener('click', radioButtonClicked);

        if (radio_button.checked) {
            activate(radio_button.getAttribute('value'));
        }
    });
})();
